<script lang="ts">
  import { fly } from 'svelte/transition';
  import { removeToast, toasts } from '../stores/toastStore';
</script>

<section>
  {#each $toasts as { id, type, message } (id)}
    <button
      type="button"
      class={type}
      transition:fly={{ y: 20, duration: 150 }}
      onclick={() => removeToast(id)}
    >
      <div class="text">
        {message}
      </div>
    </button>
  {/each}
</section>

<style>
  section {
    position: fixed;
    top: 0;
    right: 0;
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    z-index: 1000;
  }
  button {
    all: unset;
    color: var(--color-zinc-200);
    padding: 0.75rem 1.5rem;
    border-radius: 0.2rem;
    display: flex;
    align-items: center;
    margin: 0 1rem 0.5rem 0;
    width: 20rem;
    cursor: pointer;
  }
  .error {
    background: var(--color-red-800);
  }
  .success {
    background: var(--color-green-800);
  }
</style>
